import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Imagen } from '../models/imagen';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Imagen';

@Injectable({
  providedIn: 'root'
})
export class ImagenService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getDetail(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/ByPersonalId?personalId=' + code })
  }

  save(imagen: Imagen)
  {
    return this._http.post({ url: baseUrl + '/Save', body: imagen });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }
}

